import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "LeaveEntitlement";

export const getEntitle = createAsyncThunk(
  `${namespace}/leaveEntitlement`,
  async (body, { rejectWithValue }) => {
    const api = "leaveEntitlement";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

//List of Leave Entitles by ID
export const getEntitlebyID = createAsyncThunk(
  `${namespace}/getEntitlebyID`,
  async ({ id }, { rejectWithValue }) => {
    const api = "leaveEntitlementbyID";
    const replace = { 
      search: "{id}",
      replace: id 
  };
  const opt = {
      replace: replace,
  };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

//List of Leave Entitles by ID
export const updateEntitlebyID = createAsyncThunk(
  `${namespace}/updateEntitlebyID`,
  async (body, { rejectWithValue }) => {
    const api = "leaveEntitlementUpdate";
    const replace = { 
      search: "{id}",
      replace: body.id 
  };
  const opt = {
    replace: replace,
    body: body,
  };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

//List of Leave Entitles by ID
export const addEntitle = createAsyncThunk(
  `${namespace}/addEntitle`,
  async (body, { rejectWithValue }) => {
    const api = "leaveEntitlementAdd";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  entitle: {
    annual: 0,
    sick: 0,
    medical: 0,
    hospitalization: 0,
    service_length: {
      description: "",
    },
    employee_catagory: {
      description: "",
    },
    advanced: 5.0,
    special: 3.0,
    maternity: 60.0,
    status: 1,
  },
  entitles: [],
  loading: false,
  error: false,
};

const LeaveEntitlementSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    updateLeaveEntitlement(state, action) {
      return { ...state, entitle: action.payload };
    },

    resetList(state, action) {
      return {
        ...state, 
        entitle: initialState.entitle,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEntitle.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getEntitle.fulfilled, (state, action) => {
        state.loading = false;
        state.entitles = action.payload;
        console.log(action.payload);
      })
      .addCase(getEntitle.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        console.error(action.payload);
      })

      .addCase(getEntitlebyID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getEntitlebyID.fulfilled, (state, action) => {
        state.loading = false;
        state.entitle = action.payload;
        console.log(action.payload);
      })
      .addCase(getEntitlebyID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        console.error(action.payload);
      })

      .addCase(updateEntitlebyID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateEntitlebyID.fulfilled, (state, action) => {
        state.loading = false;
        state.entitle = action.payload;
        console.log(action.payload);
      })
      .addCase(updateEntitlebyID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        console.error(action.payload);
      })

      .addCase(addEntitle.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEntitle.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addEntitle.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { updateLeaveEntitlement, resetList } = LeaveEntitlementSlice.actions;
export default LeaveEntitlementSlice.reducer;